
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/state/capital-bulletin",
      function () {
        return require("private-next-pages/advocacy/state/capital-bulletin/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/state/capital-bulletin"])
      });
    }
  